import styled from 'styled-components';
import { NotReadyToBuyOnlineStyled } from '../NotReadyToBuyOnlineStyled';
export const NotReadyToBuyOnlineStyledAC = styled(NotReadyToBuyOnlineStyled)``;
